module.exports = __webpack_public_path__ + "static/media/05_tn.e84fbcbd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/black/thumbnails/05_tn.jpg
// module id = 219
// module chunks = 0